<template>

  <div id="app">

    <div>
      <vue-up></vue-up>
    </div>

    <div id="header" class="navbar-toggleable-md fixed header-sm clearfix" v-if="user">

      <!-- TOP NAV -->
      <header id="topNav">
        <div class="container">

          <button @click="deconnexion()" class="btn btn-mobile visible">
            <img src="/static/assets/img/power-button.png" width="32px"/>
            <b class="tooltip tooltip-bottom-right">Se déconnecter</b>
          </button>

          <!-- Mobile Menu Button -->
          <button class="btn btn-mobile" data-toggle="collapse" data-target=".nav-main-collapse" v-show="user && user.is_admin">
            <i class="fa fa-bars"></i>
          </button>

          <div class="navbar-collapse collapse float-right nav-main-collapse submenu-dark">
            <nav class="nav-main">

              <ul id="topMain" class="nav nav-pills nav-main">

                <li class="hover-animate-bounceIn" v-show="user && user.is_admin" @click.prevent="changePageAndActiveToggle('ZONES')">
                  <a class="dropdown-toggle noicon" href="javascript:void(0)">
                    <img src="/static/assets/img/binoculars.png" width="32px" alt="Liste des zones" title="Liste des zones"/>
                  </a>
                  <b class="tooltip tooltip-bottom-right">Liste des zones</b>
                </li>

                <li class="hover-animate-bounceIn" v-show="user && user.is_admin" @click.prevent="changePageAndActiveToggle('UTILISATEUR')">
                  <a class="dropdown-toggle noicon" href="javascript:void(0)">
                    <img src="/static/assets/img/users.png" width="32px" alt="Configuration des utilisateurs" title="Configuration des utilisateurs"/>
                  </a>
                  <b class="tooltip tooltip-bottom-right">Configuration des utilisateurs</b>
                </li>

                <li class="hover-animate-bounceIn" v-if="user && user.is_admin" @click.prevent="changePageAndActiveToggle('COMPTE')">
                  <a class="dropdown-toggle noicon" href="javascript:void(0)">
                    <img src="/static/assets/img/params.png" width="32px" alt="Paramétrage du compte administrateur" title="Paramétrage du compte administrateur"/>
                  </a>
                  <b class="tooltip tooltip-bottom-right">Paramétrage du compte administrateur</b>
                </li>

                <li class="hover-animate-bounceIn" v-if="user && user.is_admin" @click.prevent="changePageAndActiveToggle('LOG')">
                  <a class="dropdown-toggle noicon" href="javascript:void(0)">
                    <img src="/static/assets/img/log.png" width="32px" title="Logs applicatifs des actions effectuées sur le site" alt="Logs applicatifs des actions effectuées sur le site"/>
                  </a>
                  <b class="tooltip tooltip-bottom-right">Logs applicatifs des actions effectuées sur le site</b>
                </li>

              </ul>

            </nav>
          </div>

          <!-- Logo -->
          <a class="logo float-left" href="javascript:;" @click="centrageVille()">
            <span class="c-green">NODLIGHT</span> <span v-if="ville.nom" class="fs-16">CITYLI  - {{ville.nom}} ({{ville.code_postal}})</span>
          </a>

        </div>
      </header>
      <!-- /Top Nav -->

    </div>

    <transition name="slide-fade">
      <router-view :userParam="user" :updateCalendar="updateCalendar" :currentPage="current_page" :currentPageTime="current_page_time"/>
    </transition>

    <footer id="footer" v-if="!user">
      <div class="copyright">
        <div class="container">
          2018 © NodLight est une marque déposée de <a href="https://www.gce-electronics.com" title="GCE Electronics">GCE Electronics</a>
        </div>
      </div>
    </footer>

  </div>


</template>

<script>

import Vue from 'vue';

require('vue-style-loader!@/assets/css/app/app.css');
require('vue-style-loader!@/assets/css/app/modal.css');
require('vue-style-loader!@/assets/css/app/responsive.css');

import Axios from 'axios';

export default {

  data: function() {
    return {
      user: null,
      updateCalendar: 0,
      current_page_time: 0,
      current_page: "ZONE",
      ville: {},
    }
  },

  created () {

    var this_ = this;

    // Force la déconnexion
    this_.$on('decoUser', () => {
      this_.deconnexion();
    });

    this_.$on('updateCurrentPage', (currentPage) => {
      this_.current_page = currentPage;
    });

    /*
    * Supprime un evenement du calendrier depuis une librairie externe
    * Monthly.js : attr("onclick", "document.dispatchEvent(new Event('removeEvenement', 'test'))")
    */
    document.addEventListener("removeEvenement", function(event) {
      try {
      var datas = event.detail.id.split("-");
      Axios.delete(func.url_backend + '/api/nodlight/sites/' + datas[0] + '/zones/' + datas[1] + '/voies/' + datas[2] + '/horaires/' + datas[3]).then((response) => {
        this_.$emit('updateUser');
        this_.updateCalendar = datas[2];
      });

      }catch(e) {
        console.log(e);
      }
    });

    /*
    * Récupère les données de la ville
    */
    this.$on('setVille', (ville) => {
      this_.ville = ville;
    });

    /*
    * Force la maj d'un utilisateur ou affecte un utilisateur (connexion)
    */
    this.$on('updateUser', (utilisateur) => {

      if (!utilisateur){

        // Check utilisateur connecté
        try{

          // En session ?
          if (this.$session.get('user')){
            this_.setUserOk(this.$session.get('user'));
            //this_.$router.push('c');
          } else {
            this_.deconnexion();
          }

        }catch(e){
          console.log(e)
          this.deconnexion();
        }

      }else{
        // connexion
        this.$session.set('user', JSON.stringify(utilisateur));
        this.user = utilisateur;
        if (utilisateur.is_admin) {
          // Redirection vers la carte
          this.$router.push('c');
        } else {
          // Redirection vers l'espace utilisateur
          this.$router.push('a');
        }
      }

    });

    // Check utilisateur connecté
    this.$emit('updateUser');

  },

  mounted () {
    func.topNav();
  },

  methods : {

    /*
    * Change la page en cours et ouvre la page d'informations si nécessaire.
    */
    changePageAndActiveToggle: function(page) {
      this.current_page = page;

      // Force le changement (watch) pour ouvrir la page
      this.current_page_time = Date.now();
    },

    /*
    * Mise en session du user
    */
    setUserOk: function(user) {
      try {
        this.user = JSON.parse(user);
      }catch(e) {
        // Voulu
      }
    },

    /*
    * Centrage de carte vers la vile
    */
    centrageVille: function() {
      this.$emit('centrage_ville', true);
    },

    /*
    * Déconnexion utilisateur
    */
    deconnexion: function() {
      this.$session.destroy();
      this.current_page = "ZONE";
      this.user = undefined;
      this.ville = {};
      this.$router.push('/');
    }

  }

}

</script>



// WEBPACK FOOTER //
// src/App.vue